import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@/assets/scss/vuetify/index.scss';
import fr from 'vuetify/src/locale/fr';
import DeleteFDI from '@carbon/icons-vue/es/trash-can/16'
import SeeFDI from '@carbon/icons-vue/es/view/16'
import SeeCloseFDI from '@carbon/icons-vue/es/view--off/16'
import EditFDI from '@carbon/icons-vue/es/edit/16'
import PaidFDI from '@carbon/icons-vue/es/currency/16'
import DownloadFDI from '@carbon/icons-vue/es/download/16'
import DocumentFDI from '@carbon/icons-vue/es/document/16'
import ArrowUpFDI from '@carbon/icons-vue/es/chevron--up/16'
import UserFDI from '@carbon/icons-vue/es/user/24'
import DashboardFDI from '@carbon/icons-vue/es/workspace/24'
import FournisseurFDI from '@carbon/icons-vue/es/group/24'
import SettingsFDI from '@carbon/icons-vue/es/settings/24'
import FournisseursFDI from '@carbon/icons-vue/es/identification/24'
import ClientsFDI from '@carbon/icons-vue/es/identification/24'
import ContactsFDI from '@carbon/icons-vue/es/report/24'
import LogoutFDI from '@carbon/icons-vue/es/logout/16'
import NewFournisseurClientFDI from '@/components/Icons/NewFournisseurClientFDI.vue'
import AchatsFDI from '@carbon/icons-vue/es/store/24'
import AchatsChildrenFDI from '@carbon/icons-vue/es/shopping--cart/24'
import NewAchatsFDI from '@carbon/icons-vue/es/shopping--cart--plus/24'
import LivraisonsFDI from '@carbon/icons-vue/es/delivery/24'
import LivraisonAddFDI from '@carbon/icons-vue/es/delivery-truck/24'
import VentesFDI from '@carbon/icons-vue/es/finance/24'
import ListVentesFDI from '@carbon/icons-vue/es/receipt/24'
import NewVentesFDI from '@/components/Icons/NewVentes.vue'
import EssencesFDI from '@carbon/icons-vue/es/tree/24'
import LongueursFDI from '@carbon/icons-vue/es/pan--horizontal/24'
import TransportsFDI from '@carbon/icons-vue/es/delivery-truck/24'
import MarkPaidFDI from '@carbon/icons-vue/es/currency/16'
import PilesFDI from '@carbon/icons-vue/es/delivery--parcel/24'
import HomeFDI from '@carbon/icons-vue/es/home/24'
import BoxFDI from '@carbon/icons-vue/es/box/24'
import CalendarFDI from '@carbon/icons-vue/es/calendar/24'
import AddFDI from '@carbon/icons-vue/es/add/24'

Vue.use(Vuetify);

// noinspection TypeScriptValidateTypes
export default new Vuetify({
    lang: {
      locales: { fr },
      current: 'fr',
    },
	icons: {
		iconfont: 'mdi',
		values: {
			delete: { component: DeleteFDI },
			see: { component: SeeFDI },
			seeClose: { component: SeeCloseFDI },
			edit: { component: EditFDI },
			paid: { component: PaidFDI },
			download: { component: DownloadFDI },
			document: { component: DocumentFDI },
			arrow_up: { component: ArrowUpFDI },
			user: { component: UserFDI },
			dashboard: { component: DashboardFDI },
			fournisseur: { component: FournisseurFDI },
			settings: { component: SettingsFDI },
			fournisseurs: { component: FournisseursFDI },
			clients: { component: ClientsFDI },
			contacts: { component: ContactsFDI },
			logout: { component: LogoutFDI },
			new_fournisseur_client: { component: NewFournisseurClientFDI },
			achats: { component: AchatsFDI },
			achats_children: { component: AchatsChildrenFDI },
			new_achats: { component: NewAchatsFDI },
			livraisons: { component: LivraisonsFDI },
			livraisonAdd: { component: LivraisonAddFDI },
			ventes: { component: VentesFDI },
			list_ventes: { component: ListVentesFDI },
			new_ventes: { component: NewVentesFDI },
			essences: { component: EssencesFDI },
			list_longueurs: { component: LongueursFDI },
			transports: { component: TransportsFDI },
			mark_paid: { component: MarkPaidFDI },
			piles: { component: PilesFDI },
			home: { component: HomeFDI },
			box: { component: BoxFDI },
			calendar: { component: CalendarFDI },
			add: { component: AddFDI },
		}
	},
    theme: {
        themes: {
            light: {
                primary: '#FF8080',
                secondary: '#7E0707',
                accent: '#e91e63',
                error: '#7E0707',
                warning: '#ff9800',
                info: '#ffc107',
                success: '#69AE3F',
				background: '#222222',
				background_menu: '#404040',
				btn_nav: '#FF8080',
				see: '#222222',
				edit: '#222222',
				delete: '#7E0707',
				download: '#222222',
				document: '#222222',
				title: '#FFFFFF',
				subtitle: '#F3D491',
				btn_bg_add: '#F3D491',
				btn_txt_add: '#553B02',
				transparent: 'rgba(85,2,2,0)',
            }
        }
    },
});
